module.exports = __webpack_public_path__ + "static/media/photo7.16fd133c.png";